import Box from "@mui/material/Box";
import UIPopper from "@/components/popover";
import VideoTag from "@/components/VideoComponent";
import { Tooltip, Typography } from "@mui/material";

const VideoPopper = ({
  title = "",
  path = "",
  caption = null,
  tooltipText = "",
  anchorOrigin = { vertical: "top", horizontal: "right" },
  transformOrigin = { vertical: "top", horizontal: "left" },
  backdrop = false,
  width = "800",
  height = "360",
  ...props
}) => {
  return (
    <UIPopper
      style={{
        p: 0,
        borderRadius: "20px",
      }}
      anchorOrigin={{ ...anchorOrigin }}
      transformOrigin={{ ...transformOrigin }}
      backdrop={backdrop}
      {...props}
      clickNode={
        tooltipText ? (
          <Tooltip title={tooltipText} placement="top">
            <Box>{title}</Box>
          </Tooltip>
        ) : (
          title
        )
      }
    >
      {({ setAnchorEl }) => {
        return (
          <Box sx={{ position: "relative" }}>
            <VideoTag
              controls={false}
              autoPlay={true}
              preload="auther"
              customStyles={{
                minWidth: "100%",
                borderRadius: "1px",
              }}
              width={width}
              height={height}
              src={path}
              type="video/mp4"
              flush={!caption}
            />
            {caption ? (
              <Box sx={{ p: 2, mt: -4, maxWidth: "800px" }}>
                <Typography
                  variant="h5"
                  color={"custom.sub_heading"}
                  fontWeight={600}
                >
                  {caption.title}
                </Typography>
                <Typography color={"custom.grey_text"}>
                  {caption?.description}
                </Typography>
              </Box>
            ) : null}
          </Box>
        );
      }}
    </UIPopper>
  );
};

export default VideoPopper;
